"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NRail Gateway Service API - Logbook module
 * NRail Gateway Service API - Logbook module
 *
 * The version of the OpenAPI document: 1.1.9
 * Contact: it@nrail.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetaApi = exports.MetaApiFactory = exports.MetaApiFp = exports.MetaApiAxiosParamCreator = exports.MailRecipientsApi = exports.MailRecipientsApiFactory = exports.MailRecipientsApiFp = exports.MailRecipientsApiAxiosParamCreator = exports.LogbookEntriesCommentsApi = exports.LogbookEntriesCommentsApiFactory = exports.LogbookEntriesCommentsApiFp = exports.LogbookEntriesCommentsApiAxiosParamCreator = exports.LogbookEntriesApi = exports.LogbookEntriesApiFactory = exports.LogbookEntriesApiFp = exports.LogbookEntriesApiAxiosParamCreator = exports.VehicleComponentIdentifier = exports.UpdateLogbookEntry409ResponseResultCodesEnum = exports.UpdateLogbookEntry404ResponseResultCodesEnum = exports.UpdateLogbookEntry400ResponseResultCodesEnum = exports.SandState = exports.OperationMode = exports.NotificationResultCode = exports.MotorOilState = exports.LogbookEntriesExportConfigurationAcceptedMediaTypeEnum = exports.LogbookEntriesExportConfigurationTimeZoneEnum = exports.LogbookEntriesExportConfigurationLocalizationEnum = exports.IssueState = exports.HydraulicsState = exports.GetVehicleMetadataInOrganisation400ResponseResultCodesEnum = exports.GetLogbookEntryCreatorSignature404ResponseResultCodesEnum = exports.GetLogbookEntryCommentSignature404ResponseResultCodesEnum = exports.GetLogbookEntriesExportWithId404ResponseResultCodesEnum = exports.GetLogbookEntriesExportWithId400ResponseResultCodesEnum = exports.GetLogbookEntries404ResponseResultCodesEnum = exports.GetLogbookEntries400ResponseResultCodesEnum = exports.EntryStatusRead = exports.EntriesOrderByEnum = exports.EmailRecipientReadUseCaseEnum = exports.DeleteLogbookEntry409ResponseResultCodesEnum = exports.DeleteLogbookEntry400ResponseResultCodesEnum = exports.CreateLogbookEntryFinalization409ResponseResultCodesEnum = exports.CreateLogbookEntryFinalization400ResponseResultCodesEnum = exports.CreateLogbookEntryComment415ResponseResultCodesEnum = exports.CreateLogbookEntryComment409ResponseResultCodesEnum = exports.CreateLogbookEntryComment400ResponseResultCodesEnum = exports.CreateLogbookEntry415ResponseResultCodesEnum = exports.CreateLogbookEntry409ResponseResultCodesEnum = exports.CreateLogbookEntry400ResponseResultCodesEnum = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
exports.CreateLogbookEntry400ResponseResultCodesEnum = {
    Malformed: 'err_malformed',
    RequestValidation: 'err_request_validation',
    InvalidImageSize: 'err_invalid_image_size',
    MissingA1Timestamp: 'err_missing_a1_timestamp'
};
exports.CreateLogbookEntry409ResponseResultCodesEnum = {
    Vehicle: 'err_unknown_vehicle',
    CreatorAccount: 'err_unknown_creator_account',
    AccountVehicleConnection: 'err_unknown_account_vehicle_connection'
};
exports.CreateLogbookEntry415ResponseResultCodesEnum = {
    ImageSize: 'err_invalid_image_size',
    MimeType: 'err_invalid_mime_type'
};
exports.CreateLogbookEntryComment400ResponseResultCodesEnum = {
    RequestValidation: 'err_request_validation',
    Malformed: 'err_malformed',
    InvalidImageSize: 'err_invalid_image_size'
};
exports.CreateLogbookEntryComment409ResponseResultCodesEnum = {
    UnknownAccount: 'err_unknown_account',
    UnknownAccountVehicleConnection: 'err_unknown_account_vehicle_connection',
    EntryNotFinalized: 'err_entry_not_finalized'
};
exports.CreateLogbookEntryComment415ResponseResultCodesEnum = {
    ErrInvalidMimeType: 'err_invalid_mime_type'
};
exports.CreateLogbookEntryFinalization400ResponseResultCodesEnum = {
    Malformed: 'err_malformed',
    RequestValidation: 'err_request_validation',
    InvalidImageSize: 'err_invalid_image_size'
};
exports.CreateLogbookEntryFinalization409ResponseResultCodesEnum = {
    NotFinalizable: 'err_not_finalizable',
    AlreadyFinalized: 'err_already_finalized'
};
exports.DeleteLogbookEntry400ResponseResultCodesEnum = {
    ErrRequestValidation: 'err_request_validation'
};
exports.DeleteLogbookEntry409ResponseResultCodesEnum = {
    ErrAlreadyFinalized: 'err_already_finalized'
};
exports.EmailRecipientReadUseCaseEnum = {
    Defects: 'defects',
    Stoppage: 'stoppage'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.EntriesOrderByEnum = {
    LogbookEntryId: 'logbookEntryId',
    VehicleIdRef: 'vehicleIdRef',
    VehicleNumber: 'vehicleNumber',
    CreatorAccountIdRef: 'creatorAccountIdRef',
    CreatorAccountFirstName: 'creatorAccountFirstName',
    CreatorAccountLastName: 'creatorAccountLastName',
    CreatorAccountEmailAddress: 'creatorAccountEmailAddress',
    ReferenceLocation: 'referenceLocation',
    ReferenceTimestamp: 'referenceTimestamp',
    StoppageVehicleLocation: 'stoppage_vehicleLocation',
    CreateTimestamp: 'createTimestamp',
    Status: 'status',
    IsFinalizable: 'isFinalizable',
    StoppageState: 'stoppage_state',
    DefectsState: 'defects_state',
    EntryState: 'entryState',
    CommentsCount: 'commentsCount',
    TrainNumber: 'trainNumber',
    StoppageLastOperationMode: 'stoppage_lastOperationMode',
    StoppageWasAuxiliaryVehicleUsed: 'stoppage_wasAuxiliaryVehicleUsed',
    LastCommentCreateTimestamp: 'lastComment_createTimestamp',
    LastCommentCreatorAccountFirstName: 'lastComment_creatorAccountFirstName',
    LastCommentCreatorAccountLastName: 'lastComment_creatorAccountLastName',
    LastCommentCreatorAccountEmailAddress: 'lastComment_creatorAccountEmailAddress',
    LastCommentNewEntryState: 'lastComment_newEntryState',
    VehicleStateVehicleOperatingHoursH: 'vehicleState_vehicleOperatingHours_h',
    LogbookEntryIdAsc: 'logbookEntryId asc',
    VehicleIdRefAsc: 'vehicleIdRef asc',
    VehicleNumberAsc: 'vehicleNumber asc',
    CreatorAccountIdRefAsc: 'creatorAccountIdRef asc',
    CreatorAccountFirstNameAsc: 'creatorAccountFirstName asc',
    CreatorAccountLastNameAsc: 'creatorAccountLastName asc',
    CreatorAccountEmailAddressAsc: 'creatorAccountEmailAddress asc',
    ReferenceLocationAsc: 'referenceLocation asc',
    ReferenceTimestampAsc: 'referenceTimestamp asc',
    StoppageVehicleLocationAsc: 'stoppage_vehicleLocation asc',
    CreateTimestampAsc: 'createTimestamp asc',
    StatusAsc: 'status asc',
    IsFinalizableAsc: 'isFinalizable asc',
    StoppageStateAsc: 'stoppage_state asc',
    DefectsStateAsc: 'defects_state asc',
    EntryStateAsc: 'entryState asc',
    CommentsCountAsc: 'commentsCount asc',
    TrainNumberAsc: 'trainNumber asc',
    StoppageLastOperationModeAsc: 'stoppage_lastOperationMode asc',
    StoppageWasAuxiliaryVehicleUsedAsc: 'stoppage_wasAuxiliaryVehicleUsed asc',
    LastCommentCreateTimestampAsc: 'lastComment_createTimestamp asc',
    LastCommentCreatorAccountFirstNameAsc: 'lastComment_creatorAccountFirstName asc',
    LastCommentCreatorAccountLastNameAsc: 'lastComment_creatorAccountLastName asc',
    LastCommentCreatorAccountEmailAddressAsc: 'lastComment_creatorAccountEmailAddress asc',
    LastCommentNewEntryStateAsc: 'lastComment_newEntryState asc',
    VehicleStateVehicleOperatingHoursHAsc: 'vehicleState_vehicleOperatingHours_h asc',
    LogbookEntryIdDesc: 'logbookEntryId desc',
    VehicleIdRefDesc: 'vehicleIdRef desc',
    VehicleNumberDesc: 'vehicleNumber desc',
    CreatorAccountIdRefDesc: 'creatorAccountIdRef desc',
    CreatorAccountFirstNameDesc: 'creatorAccountFirstName desc',
    CreatorAccountLastNameDesc: 'creatorAccountLastName desc',
    CreatorAccountEmailAddressDesc: 'creatorAccountEmailAddress desc',
    ReferenceLocationDesc: 'referenceLocation desc',
    ReferenceTimestampDesc: 'referenceTimestamp desc',
    StoppageVehicleLocationDesc: 'stoppage_vehicleLocation desc',
    CreateTimestampDesc: 'createTimestamp desc',
    StatusDesc: 'status desc',
    IsFinalizableDesc: 'isFinalizable desc',
    StoppageStateDesc: 'stoppage_state desc',
    DefectsStateDesc: 'defects_state desc',
    EntryStateDesc: 'entryState desc',
    CommentsCountDesc: 'commentsCount desc',
    TrainNumberDesc: 'trainNumber desc',
    StoppageLastOperationModeDesc: 'stoppage_lastOperationMode desc',
    StoppageWasAuxiliaryVehicleUsedDesc: 'stoppage_wasAuxiliaryVehicleUsed desc',
    LastCommentCreateTimestampDesc: 'lastComment_createTimestamp desc',
    LastCommentCreatorAccountFirstNameDesc: 'lastComment_creatorAccountFirstName desc',
    LastCommentCreatorAccountLastNameDesc: 'lastComment_creatorAccountLastName desc',
    LastCommentCreatorAccountEmailAddressDesc: 'lastComment_creatorAccountEmailAddress desc',
    LastCommentNewEntryStateDesc: 'lastComment_newEntryState desc',
    VehicleStateVehicleOperatingHoursHDesc: 'vehicleState_vehicleOperatingHours_h desc'
};
/**
 * The entry is created or finalized
 * @export
 * @enum {string}
 */
exports.EntryStatusRead = {
    Created: 'created',
    Finalized: 'finalized'
};
exports.GetLogbookEntries400ResponseResultCodesEnum = {
    RequestValidation: 'err_request_validation',
    MalformedOdata: 'err_malformed_odata',
    InvalidOdataProperty: 'err_invalid_odata_property'
};
exports.GetLogbookEntries404ResponseResultCodesEnum = {
    ErrUnknownOrganisation: 'err_unknown_organisation'
};
exports.GetLogbookEntriesExportWithId400ResponseResultCodesEnum = {
    RequestValidation: 'err_request_validation',
    MalformedOdata: 'err_malformed_odata',
    InvalidOdataProperty: 'err_invalid_odata_property',
    InvalidFilterParameter: 'err_invalid_filter_parameter'
};
exports.GetLogbookEntriesExportWithId404ResponseResultCodesEnum = {
    ErrUnknownExport: 'err_unknown_export'
};
exports.GetLogbookEntryCommentSignature404ResponseResultCodesEnum = {
    Entry: 'err_unknown_entry',
    Organisation: 'err_unknown_organisation',
    Comment: 'err_unknown_comment'
};
exports.GetLogbookEntryCreatorSignature404ResponseResultCodesEnum = {
    Entry: 'err_unknown_entry',
    Organisation: 'err_unknown_organisation'
};
exports.GetVehicleMetadataInOrganisation400ResponseResultCodesEnum = {
    Malformed: 'err_malformed',
    RequestValidation: 'err_request_validation',
    InvalidOdataProperty: 'err_invalid_odata_property',
    MalformedOdata: 'err_malformed_odata'
};
/**
 * [REQUIRED FOR FINALIZATION] The state of the hydraulics system.
 * @export
 * @enum {string}
 */
exports.HydraulicsState = {
    Ok: 'ok',
    NotOk: 'not_ok',
    Null: 'null'
};
/**
 * [REQUIRED FOR FINALIZATION] The state of the issue
 * @export
 * @enum {string}
 */
exports.IssueState = {
    Open: 'open',
    Resolved: 'resolved'
};
exports.LogbookEntriesExportConfigurationLocalizationEnum = {
    DeDe: 'de-DE'
};
exports.LogbookEntriesExportConfigurationTimeZoneEnum = {
    EuropeBerlin: 'Europe/Berlin'
};
exports.LogbookEntriesExportConfigurationAcceptedMediaTypeEnum = {
    ApplicationVndMsExcel: 'application/vnd.ms-excel',
    TextCsvCharsetutf8: 'text/csv; charset=utf-8'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.MotorOilState = {
    Ok: 'ok',
    NotOk: 'not_ok',
    Null: 'null'
};
/**
 * The result code of the notification sending
 * @export
 * @enum {string}
 */
exports.NotificationResultCode = {
    Ok: 'ok',
    NotSent: 'not_sent',
    ErrCannotSend: 'err_cannot_send'
};
/**
 * [REQUIRED FOR FINALIZATION]
 * @export
 * @enum {string}
 */
exports.OperationMode = {
    RemoteControl: 'remote_control',
    Manual: 'manual',
    Null: 'null'
};
/**
 * [REQUIRED FOR FINALIZATION]
 * @export
 * @enum {string}
 */
exports.SandState = {
    Ok: 'ok',
    NotOk: 'not_ok',
    Null: 'null'
};
exports.UpdateLogbookEntry400ResponseResultCodesEnum = {
    Malformed: 'err_malformed',
    RequestValidation: 'err_request_validation'
};
exports.UpdateLogbookEntry404ResponseResultCodesEnum = {
    Organisation: 'err_unknown_organisation',
    Entry: 'err_unknown_entry'
};
exports.UpdateLogbookEntry409ResponseResultCodesEnum = {
    AlreadyFinalized: 'err_already_finalized',
    CreatorAccountMismatch: 'err_creator_account_mismatch'
};
/**
 * A vehicle component. PZB -> Punktförmige Zugbeeinflussung.
 * @export
 * @enum {string}
 */
exports.VehicleComponentIdentifier = {
    Engine: 'engine',
    RemoteControl: 'remote_control',
    FuelSystem: 'fuel_system',
    CoolingSystem: 'cooling_system',
    PowerControl: 'power_control',
    Transmission: 'transmission',
    Undercarriage: 'undercarriage',
    Generators: 'generators',
    Battery: 'battery',
    SafetyDeadmanCircuit: 'safety_deadman_circuit',
    PzbSystem: 'pzb_system',
    GsmRailSystem: 'gsm_rail_system',
    MiscElectronicSystems: 'misc_electronic_systems',
    BrakesAndAirPressureSystem: 'brakes_and_air_pressure_system'
};
/**
 * LogbookEntriesApi - axios parameter creator
 * @export
 */
const LogbookEntriesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Creates export for multiple logbook entries within a given organisation. The results can be customized by use of the OData query parameters. The ID of the export is returned to be used with getLogbookEntriesExportWithId. The ID can only be used once. The ID is valid for 1 minute after creation. NOTE - OData parameters $count and $search are not supported. Requesting user must have sufficiant access rights. Required access rights:   logbook_entries/all, canRead   OR   logbook_entries, canRead
         * @summary createLogbookEntriesExport - Create an export for multiple logbook entries ✅
         * @param {string} organisationId The ID of the organisation
         * @param {LogbookEntriesExportConfiguration} logbookEntriesExportConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLogbookEntriesExport: async (organisationId, logbookEntriesExportConfiguration, options = {}) => {
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('createLogbookEntriesExport', 'organisationId', organisationId);
            // verify required parameter 'logbookEntriesExportConfiguration' is not null or undefined
            common_1.assertParamExists('createLogbookEntriesExport', 'logbookEntriesExportConfiguration', logbookEntriesExportConfiguration);
            const localVarPath = `/organisations/{organisationId}/logbook-entries/export`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(logbookEntriesExportConfiguration, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a logbook entry within a given organisation. A image of the creator\'s signature must be provided along with the JSON data. The only modification that can be done to this entry after this operation was successfull is appending comments. The requesting account as identified by the provided access token will be regarded as the creator. The requesting account must have sufficient rights to perform this operation. Required access rights:   logbook_entries/all, canCreate   OR   logbook_entries, canCreate  Returns 400, err_missing_a1_timestamp in case   no A1 timestamp is provided   and   (     no last recorded A1 timestamp for that vehicle in that organisation     or     last recorded A1 timestamp for that vehicle in that organisation   )  vehicle in that organisation is more than 24 h away in the past from the create timestamp. A notification email will be sent when: the stoppage and damage conditions are met AND (   no mail ha been send for that entry   OR   send_optional_notification is set to true )
         * @summary createLogbookEntry - Create a logbook entry ✅
         * @param {string} organisationId The ID of the organisation
         * @param {LogbookEntryCreate} logbookEntryCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLogbookEntry: async (organisationId, logbookEntryCreate, options = {}) => {
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('createLogbookEntry', 'organisationId', organisationId);
            // verify required parameter 'logbookEntryCreate' is not null or undefined
            common_1.assertParamExists('createLogbookEntry', 'logbookEntryCreate', logbookEntryCreate);
            const localVarPath = `/organisations/{organisationId}/logbook-entries`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(logbookEntryCreate, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a finalization for. a logbook entry within a given organisation. Required access rights:   logbook_entries/all, canUpdate   OR (     logbook_entries, canUpdate ( in  the organisation )     AND     the the requesting account must be the creator   )
         * @summary createLogbookEntryFinalization - Finalize a logbook entry
         * @param {string} organisationId The ID of the organisation
         * @param {string} logbookEntryId The ID of the logbook entry
         * @param {LogbookEntryFinalization} logbookEntryFinalization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLogbookEntryFinalization: async (organisationId, logbookEntryId, logbookEntryFinalization, options = {}) => {
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('createLogbookEntryFinalization', 'organisationId', organisationId);
            // verify required parameter 'logbookEntryId' is not null or undefined
            common_1.assertParamExists('createLogbookEntryFinalization', 'logbookEntryId', logbookEntryId);
            // verify required parameter 'logbookEntryFinalization' is not null or undefined
            common_1.assertParamExists('createLogbookEntryFinalization', 'logbookEntryFinalization', logbookEntryFinalization);
            const localVarPath = `/organisations/{organisationId}/logbook-entries/{logbookEntryId}/finalization`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)))
                .replace(`{${"logbookEntryId"}}`, encodeURIComponent(String(logbookEntryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(logbookEntryFinalization, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a non-finalized logbook entry within a given organisation. Required access rights:   logbook_entries/all, canDelete   OR (     logbook_entries, canDelete ( in the organisation )     AND     the requesting account must be the creator   )   OR (     logbook_entries/in_organisation, canDelete ( in the organisation )   )
         * @summary deleteLogbookEntry - Delete a logbook entry
         * @param {string} organisationId The ID of the organisation
         * @param {string} logbookEntryId The ID of the logbook entry
         * @param {string} [sendOptionalNotification] When set to true notifications will be sent even if for that entry notifications were sent before. Notifications are only sent when the entry meets the basic conditions for sending notifications.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLogbookEntry: async (organisationId, logbookEntryId, sendOptionalNotification, options = {}) => {
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('deleteLogbookEntry', 'organisationId', organisationId);
            // verify required parameter 'logbookEntryId' is not null or undefined
            common_1.assertParamExists('deleteLogbookEntry', 'logbookEntryId', logbookEntryId);
            const localVarPath = `/organisations/{organisationId}/logbook-entries/{logbookEntryId}`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)))
                .replace(`{${"logbookEntryId"}}`, encodeURIComponent(String(logbookEntryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (sendOptionalNotification !== undefined) {
                localVarQueryParameter['send_optional_notification'] = sendOptionalNotification;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns multiple logbook entries within a given organisation. The results can be customized by use of the OData query parameters. Requesting user must have sufficiant access rights. Required access rights:   logbook_entries/all, canRead   OR   logbook_entries, canRead
         * @summary getLogbookEntries - Get multiple logbook entries ✅
         * @param {string} organisationId The ID of the organisation
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {Set<EntriesOrderByEnum>} [$orderby] An OData conformant $orderby string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogbookEntries: async (organisationId, $top, $skip, $filter, $count, $orderby, options = {}) => {
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('getLogbookEntries', 'organisationId', organisationId);
            const localVarPath = `/organisations/{organisationId}/logbook-entries`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }
            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }
            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }
            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }
            if ($orderby) {
                localVarQueryParameter['$orderby'] = Array.from($orderby).join(base_1.COLLECTION_FORMATS.pipes);
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns file for a previously created export for multiple logbook entries. The {exportId} must be aquired via the createLogbookEntriesExport route. The {exportId} can only be used once. The {exportId} is valid for 1 minute after its creation.
         * @summary getLogbookEntriesExportWithId - Returns file for a previously created export for multiple logbook entries
         * @param {string} exportId The ID of the export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogbookEntriesExportWithId: async (exportId, options = {}) => {
            // verify required parameter 'exportId' is not null or undefined
            common_1.assertParamExists('getLogbookEntriesExportWithId', 'exportId', exportId);
            const localVarPath = `/logbook-entries/export/{exportId}`
                .replace(`{${"exportId"}}`, encodeURIComponent(String(exportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the signature image of the creator logbook entry {logbookEntryId} in organisation {organisationtId}. Requesting user must have sufficiant access rights. Required access rights:   logbook_entries/all, canRead   OR   logbook_entries, canRead
         * @summary getLogbookEntryCreatorSignature - Return the image of the signature of the creator of the logbook entry within a given organisation ✅
         * @param {string} organisationId The ID of the organisation
         * @param {string} logbookEntryId The ID of the logbook entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogbookEntryCreatorSignature: async (organisationId, logbookEntryId, options = {}) => {
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('getLogbookEntryCreatorSignature', 'organisationId', organisationId);
            // verify required parameter 'logbookEntryId' is not null or undefined
            common_1.assertParamExists('getLogbookEntryCreatorSignature', 'logbookEntryId', logbookEntryId);
            const localVarPath = `/organisations/{organisationId}/logbook-entries/{logbookEntryId}/signature`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)))
                .replace(`{${"logbookEntryId"}}`, encodeURIComponent(String(logbookEntryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a logbook entry within a given organisation. Required access rights:   logbook_entries/all, canUpdate   OR (     logbook_entries, canUpdate ( in the organisation )     AND     the the requesting account must be the creator   )   A notification email will be sent when:   the stoppage and damage conditions are met   AND (     no mail has been send for that entry     OR     send_optional_notification is set to true   )
         * @summary updateLogbookEntry - Update a logbook entry
         * @param {string} organisationId The ID of the organisation
         * @param {string} logbookEntryId The ID of the logbook entry
         * @param {LogbookEntryUpdate} logbookEntryUpdate
         * @param {string} [sendOptionalNotification] When set to true notifications will be sent even if for that entry notifications were sent before. Notifications are only sent when the entry meets the basic conditions for sending notifications.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLogbookEntry: async (organisationId, logbookEntryId, logbookEntryUpdate, sendOptionalNotification, options = {}) => {
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('updateLogbookEntry', 'organisationId', organisationId);
            // verify required parameter 'logbookEntryId' is not null or undefined
            common_1.assertParamExists('updateLogbookEntry', 'logbookEntryId', logbookEntryId);
            // verify required parameter 'logbookEntryUpdate' is not null or undefined
            common_1.assertParamExists('updateLogbookEntry', 'logbookEntryUpdate', logbookEntryUpdate);
            const localVarPath = `/organisations/{organisationId}/logbook-entries/{logbookEntryId}`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)))
                .replace(`{${"logbookEntryId"}}`, encodeURIComponent(String(logbookEntryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (sendOptionalNotification !== undefined) {
                localVarQueryParameter['send_optional_notification'] = sendOptionalNotification;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(logbookEntryUpdate, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.LogbookEntriesApiAxiosParamCreator = LogbookEntriesApiAxiosParamCreator;
/**
 * LogbookEntriesApi - functional programming interface
 * @export
 */
const LogbookEntriesApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.LogbookEntriesApiAxiosParamCreator(configuration);
    return {
        /**
         * Creates export for multiple logbook entries within a given organisation. The results can be customized by use of the OData query parameters. The ID of the export is returned to be used with getLogbookEntriesExportWithId. The ID can only be used once. The ID is valid for 1 minute after creation. NOTE - OData parameters $count and $search are not supported. Requesting user must have sufficiant access rights. Required access rights:   logbook_entries/all, canRead   OR   logbook_entries, canRead
         * @summary createLogbookEntriesExport - Create an export for multiple logbook entries ✅
         * @param {string} organisationId The ID of the organisation
         * @param {LogbookEntriesExportConfiguration} logbookEntriesExportConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLogbookEntriesExport(organisationId, logbookEntriesExportConfiguration, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLogbookEntriesExport(organisationId, logbookEntriesExportConfiguration, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Creates a logbook entry within a given organisation. A image of the creator\'s signature must be provided along with the JSON data. The only modification that can be done to this entry after this operation was successfull is appending comments. The requesting account as identified by the provided access token will be regarded as the creator. The requesting account must have sufficient rights to perform this operation. Required access rights:   logbook_entries/all, canCreate   OR   logbook_entries, canCreate  Returns 400, err_missing_a1_timestamp in case   no A1 timestamp is provided   and   (     no last recorded A1 timestamp for that vehicle in that organisation     or     last recorded A1 timestamp for that vehicle in that organisation   )  vehicle in that organisation is more than 24 h away in the past from the create timestamp. A notification email will be sent when: the stoppage and damage conditions are met AND (   no mail ha been send for that entry   OR   send_optional_notification is set to true )
         * @summary createLogbookEntry - Create a logbook entry ✅
         * @param {string} organisationId The ID of the organisation
         * @param {LogbookEntryCreate} logbookEntryCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLogbookEntry(organisationId, logbookEntryCreate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLogbookEntry(organisationId, logbookEntryCreate, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Create a finalization for. a logbook entry within a given organisation. Required access rights:   logbook_entries/all, canUpdate   OR (     logbook_entries, canUpdate ( in  the organisation )     AND     the the requesting account must be the creator   )
         * @summary createLogbookEntryFinalization - Finalize a logbook entry
         * @param {string} organisationId The ID of the organisation
         * @param {string} logbookEntryId The ID of the logbook entry
         * @param {LogbookEntryFinalization} logbookEntryFinalization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLogbookEntryFinalization(organisationId, logbookEntryId, logbookEntryFinalization, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLogbookEntryFinalization(organisationId, logbookEntryId, logbookEntryFinalization, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Delete a non-finalized logbook entry within a given organisation. Required access rights:   logbook_entries/all, canDelete   OR (     logbook_entries, canDelete ( in the organisation )     AND     the requesting account must be the creator   )   OR (     logbook_entries/in_organisation, canDelete ( in the organisation )   )
         * @summary deleteLogbookEntry - Delete a logbook entry
         * @param {string} organisationId The ID of the organisation
         * @param {string} logbookEntryId The ID of the logbook entry
         * @param {string} [sendOptionalNotification] When set to true notifications will be sent even if for that entry notifications were sent before. Notifications are only sent when the entry meets the basic conditions for sending notifications.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLogbookEntry(organisationId, logbookEntryId, sendOptionalNotification, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLogbookEntry(organisationId, logbookEntryId, sendOptionalNotification, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Returns multiple logbook entries within a given organisation. The results can be customized by use of the OData query parameters. Requesting user must have sufficiant access rights. Required access rights:   logbook_entries/all, canRead   OR   logbook_entries, canRead
         * @summary getLogbookEntries - Get multiple logbook entries ✅
         * @param {string} organisationId The ID of the organisation
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {Set<EntriesOrderByEnum>} [$orderby] An OData conformant $orderby string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLogbookEntries(organisationId, $top, $skip, $filter, $count, $orderby, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLogbookEntries(organisationId, $top, $skip, $filter, $count, $orderby, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Returns file for a previously created export for multiple logbook entries. The {exportId} must be aquired via the createLogbookEntriesExport route. The {exportId} can only be used once. The {exportId} is valid for 1 minute after its creation.
         * @summary getLogbookEntriesExportWithId - Returns file for a previously created export for multiple logbook entries
         * @param {string} exportId The ID of the export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLogbookEntriesExportWithId(exportId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLogbookEntriesExportWithId(exportId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Return the signature image of the creator logbook entry {logbookEntryId} in organisation {organisationtId}. Requesting user must have sufficiant access rights. Required access rights:   logbook_entries/all, canRead   OR   logbook_entries, canRead
         * @summary getLogbookEntryCreatorSignature - Return the image of the signature of the creator of the logbook entry within a given organisation ✅
         * @param {string} organisationId The ID of the organisation
         * @param {string} logbookEntryId The ID of the logbook entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLogbookEntryCreatorSignature(organisationId, logbookEntryId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLogbookEntryCreatorSignature(organisationId, logbookEntryId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Update a logbook entry within a given organisation. Required access rights:   logbook_entries/all, canUpdate   OR (     logbook_entries, canUpdate ( in the organisation )     AND     the the requesting account must be the creator   )   A notification email will be sent when:   the stoppage and damage conditions are met   AND (     no mail has been send for that entry     OR     send_optional_notification is set to true   )
         * @summary updateLogbookEntry - Update a logbook entry
         * @param {string} organisationId The ID of the organisation
         * @param {string} logbookEntryId The ID of the logbook entry
         * @param {LogbookEntryUpdate} logbookEntryUpdate
         * @param {string} [sendOptionalNotification] When set to true notifications will be sent even if for that entry notifications were sent before. Notifications are only sent when the entry meets the basic conditions for sending notifications.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLogbookEntry(organisationId, logbookEntryId, logbookEntryUpdate, sendOptionalNotification, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLogbookEntry(organisationId, logbookEntryId, logbookEntryUpdate, sendOptionalNotification, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.LogbookEntriesApiFp = LogbookEntriesApiFp;
/**
 * LogbookEntriesApi - factory interface
 * @export
 */
const LogbookEntriesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.LogbookEntriesApiFp(configuration);
    return {
        /**
         * Creates export for multiple logbook entries within a given organisation. The results can be customized by use of the OData query parameters. The ID of the export is returned to be used with getLogbookEntriesExportWithId. The ID can only be used once. The ID is valid for 1 minute after creation. NOTE - OData parameters $count and $search are not supported. Requesting user must have sufficiant access rights. Required access rights:   logbook_entries/all, canRead   OR   logbook_entries, canRead
         * @summary createLogbookEntriesExport - Create an export for multiple logbook entries ✅
         * @param {string} organisationId The ID of the organisation
         * @param {LogbookEntriesExportConfiguration} logbookEntriesExportConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLogbookEntriesExport(organisationId, logbookEntriesExportConfiguration, options) {
            return localVarFp.createLogbookEntriesExport(organisationId, logbookEntriesExportConfiguration, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a logbook entry within a given organisation. A image of the creator\'s signature must be provided along with the JSON data. The only modification that can be done to this entry after this operation was successfull is appending comments. The requesting account as identified by the provided access token will be regarded as the creator. The requesting account must have sufficient rights to perform this operation. Required access rights:   logbook_entries/all, canCreate   OR   logbook_entries, canCreate  Returns 400, err_missing_a1_timestamp in case   no A1 timestamp is provided   and   (     no last recorded A1 timestamp for that vehicle in that organisation     or     last recorded A1 timestamp for that vehicle in that organisation   )  vehicle in that organisation is more than 24 h away in the past from the create timestamp. A notification email will be sent when: the stoppage and damage conditions are met AND (   no mail ha been send for that entry   OR   send_optional_notification is set to true )
         * @summary createLogbookEntry - Create a logbook entry ✅
         * @param {string} organisationId The ID of the organisation
         * @param {LogbookEntryCreate} logbookEntryCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLogbookEntry(organisationId, logbookEntryCreate, options) {
            return localVarFp.createLogbookEntry(organisationId, logbookEntryCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a finalization for. a logbook entry within a given organisation. Required access rights:   logbook_entries/all, canUpdate   OR (     logbook_entries, canUpdate ( in  the organisation )     AND     the the requesting account must be the creator   )
         * @summary createLogbookEntryFinalization - Finalize a logbook entry
         * @param {string} organisationId The ID of the organisation
         * @param {string} logbookEntryId The ID of the logbook entry
         * @param {LogbookEntryFinalization} logbookEntryFinalization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLogbookEntryFinalization(organisationId, logbookEntryId, logbookEntryFinalization, options) {
            return localVarFp.createLogbookEntryFinalization(organisationId, logbookEntryId, logbookEntryFinalization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a non-finalized logbook entry within a given organisation. Required access rights:   logbook_entries/all, canDelete   OR (     logbook_entries, canDelete ( in the organisation )     AND     the requesting account must be the creator   )   OR (     logbook_entries/in_organisation, canDelete ( in the organisation )   )
         * @summary deleteLogbookEntry - Delete a logbook entry
         * @param {string} organisationId The ID of the organisation
         * @param {string} logbookEntryId The ID of the logbook entry
         * @param {string} [sendOptionalNotification] When set to true notifications will be sent even if for that entry notifications were sent before. Notifications are only sent when the entry meets the basic conditions for sending notifications.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLogbookEntry(organisationId, logbookEntryId, sendOptionalNotification, options) {
            return localVarFp.deleteLogbookEntry(organisationId, logbookEntryId, sendOptionalNotification, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns multiple logbook entries within a given organisation. The results can be customized by use of the OData query parameters. Requesting user must have sufficiant access rights. Required access rights:   logbook_entries/all, canRead   OR   logbook_entries, canRead
         * @summary getLogbookEntries - Get multiple logbook entries ✅
         * @param {string} organisationId The ID of the organisation
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {Set<EntriesOrderByEnum>} [$orderby] An OData conformant $orderby string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogbookEntries(organisationId, $top, $skip, $filter, $count, $orderby, options) {
            return localVarFp.getLogbookEntries(organisationId, $top, $skip, $filter, $count, $orderby, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns file for a previously created export for multiple logbook entries. The {exportId} must be aquired via the createLogbookEntriesExport route. The {exportId} can only be used once. The {exportId} is valid for 1 minute after its creation.
         * @summary getLogbookEntriesExportWithId - Returns file for a previously created export for multiple logbook entries
         * @param {string} exportId The ID of the export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogbookEntriesExportWithId(exportId, options) {
            return localVarFp.getLogbookEntriesExportWithId(exportId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the signature image of the creator logbook entry {logbookEntryId} in organisation {organisationtId}. Requesting user must have sufficiant access rights. Required access rights:   logbook_entries/all, canRead   OR   logbook_entries, canRead
         * @summary getLogbookEntryCreatorSignature - Return the image of the signature of the creator of the logbook entry within a given organisation ✅
         * @param {string} organisationId The ID of the organisation
         * @param {string} logbookEntryId The ID of the logbook entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogbookEntryCreatorSignature(organisationId, logbookEntryId, options) {
            return localVarFp.getLogbookEntryCreatorSignature(organisationId, logbookEntryId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a logbook entry within a given organisation. Required access rights:   logbook_entries/all, canUpdate   OR (     logbook_entries, canUpdate ( in the organisation )     AND     the the requesting account must be the creator   )   A notification email will be sent when:   the stoppage and damage conditions are met   AND (     no mail has been send for that entry     OR     send_optional_notification is set to true   )
         * @summary updateLogbookEntry - Update a logbook entry
         * @param {string} organisationId The ID of the organisation
         * @param {string} logbookEntryId The ID of the logbook entry
         * @param {LogbookEntryUpdate} logbookEntryUpdate
         * @param {string} [sendOptionalNotification] When set to true notifications will be sent even if for that entry notifications were sent before. Notifications are only sent when the entry meets the basic conditions for sending notifications.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLogbookEntry(organisationId, logbookEntryId, logbookEntryUpdate, sendOptionalNotification, options) {
            return localVarFp.updateLogbookEntry(organisationId, logbookEntryId, logbookEntryUpdate, sendOptionalNotification, options).then((request) => request(axios, basePath));
        },
    };
};
exports.LogbookEntriesApiFactory = LogbookEntriesApiFactory;
/**
 * LogbookEntriesApi - object-oriented interface
 * @export
 * @class LogbookEntriesApi
 * @extends {BaseAPI}
 */
class LogbookEntriesApi extends base_1.BaseAPI {
    /**
     * Creates export for multiple logbook entries within a given organisation. The results can be customized by use of the OData query parameters. The ID of the export is returned to be used with getLogbookEntriesExportWithId. The ID can only be used once. The ID is valid for 1 minute after creation. NOTE - OData parameters $count and $search are not supported. Requesting user must have sufficiant access rights. Required access rights:   logbook_entries/all, canRead   OR   logbook_entries, canRead
     * @summary createLogbookEntriesExport - Create an export for multiple logbook entries ✅
     * @param {string} organisationId The ID of the organisation
     * @param {LogbookEntriesExportConfiguration} logbookEntriesExportConfiguration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogbookEntriesApi
     */
    createLogbookEntriesExport(organisationId, logbookEntriesExportConfiguration, options) {
        return exports.LogbookEntriesApiFp(this.configuration).createLogbookEntriesExport(organisationId, logbookEntriesExportConfiguration, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a logbook entry within a given organisation. A image of the creator\'s signature must be provided along with the JSON data. The only modification that can be done to this entry after this operation was successfull is appending comments. The requesting account as identified by the provided access token will be regarded as the creator. The requesting account must have sufficient rights to perform this operation. Required access rights:   logbook_entries/all, canCreate   OR   logbook_entries, canCreate  Returns 400, err_missing_a1_timestamp in case   no A1 timestamp is provided   and   (     no last recorded A1 timestamp for that vehicle in that organisation     or     last recorded A1 timestamp for that vehicle in that organisation   )  vehicle in that organisation is more than 24 h away in the past from the create timestamp. A notification email will be sent when: the stoppage and damage conditions are met AND (   no mail ha been send for that entry   OR   send_optional_notification is set to true )
     * @summary createLogbookEntry - Create a logbook entry ✅
     * @param {string} organisationId The ID of the organisation
     * @param {LogbookEntryCreate} logbookEntryCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogbookEntriesApi
     */
    createLogbookEntry(organisationId, logbookEntryCreate, options) {
        return exports.LogbookEntriesApiFp(this.configuration).createLogbookEntry(organisationId, logbookEntryCreate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a finalization for. a logbook entry within a given organisation. Required access rights:   logbook_entries/all, canUpdate   OR (     logbook_entries, canUpdate ( in  the organisation )     AND     the the requesting account must be the creator   )
     * @summary createLogbookEntryFinalization - Finalize a logbook entry
     * @param {string} organisationId The ID of the organisation
     * @param {string} logbookEntryId The ID of the logbook entry
     * @param {LogbookEntryFinalization} logbookEntryFinalization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogbookEntriesApi
     */
    createLogbookEntryFinalization(organisationId, logbookEntryId, logbookEntryFinalization, options) {
        return exports.LogbookEntriesApiFp(this.configuration).createLogbookEntryFinalization(organisationId, logbookEntryId, logbookEntryFinalization, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete a non-finalized logbook entry within a given organisation. Required access rights:   logbook_entries/all, canDelete   OR (     logbook_entries, canDelete ( in the organisation )     AND     the requesting account must be the creator   )   OR (     logbook_entries/in_organisation, canDelete ( in the organisation )   )
     * @summary deleteLogbookEntry - Delete a logbook entry
     * @param {string} organisationId The ID of the organisation
     * @param {string} logbookEntryId The ID of the logbook entry
     * @param {string} [sendOptionalNotification] When set to true notifications will be sent even if for that entry notifications were sent before. Notifications are only sent when the entry meets the basic conditions for sending notifications.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogbookEntriesApi
     */
    deleteLogbookEntry(organisationId, logbookEntryId, sendOptionalNotification, options) {
        return exports.LogbookEntriesApiFp(this.configuration).deleteLogbookEntry(organisationId, logbookEntryId, sendOptionalNotification, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns multiple logbook entries within a given organisation. The results can be customized by use of the OData query parameters. Requesting user must have sufficiant access rights. Required access rights:   logbook_entries/all, canRead   OR   logbook_entries, canRead
     * @summary getLogbookEntries - Get multiple logbook entries ✅
     * @param {string} organisationId The ID of the organisation
     * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
     * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {Set<EntriesOrderByEnum>} [$orderby] An OData conformant $orderby string
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogbookEntriesApi
     */
    getLogbookEntries(organisationId, $top, $skip, $filter, $count, $orderby, options) {
        return exports.LogbookEntriesApiFp(this.configuration).getLogbookEntries(organisationId, $top, $skip, $filter, $count, $orderby, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns file for a previously created export for multiple logbook entries. The {exportId} must be aquired via the createLogbookEntriesExport route. The {exportId} can only be used once. The {exportId} is valid for 1 minute after its creation.
     * @summary getLogbookEntriesExportWithId - Returns file for a previously created export for multiple logbook entries
     * @param {string} exportId The ID of the export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogbookEntriesApi
     */
    getLogbookEntriesExportWithId(exportId, options) {
        return exports.LogbookEntriesApiFp(this.configuration).getLogbookEntriesExportWithId(exportId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Return the signature image of the creator logbook entry {logbookEntryId} in organisation {organisationtId}. Requesting user must have sufficiant access rights. Required access rights:   logbook_entries/all, canRead   OR   logbook_entries, canRead
     * @summary getLogbookEntryCreatorSignature - Return the image of the signature of the creator of the logbook entry within a given organisation ✅
     * @param {string} organisationId The ID of the organisation
     * @param {string} logbookEntryId The ID of the logbook entry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogbookEntriesApi
     */
    getLogbookEntryCreatorSignature(organisationId, logbookEntryId, options) {
        return exports.LogbookEntriesApiFp(this.configuration).getLogbookEntryCreatorSignature(organisationId, logbookEntryId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update a logbook entry within a given organisation. Required access rights:   logbook_entries/all, canUpdate   OR (     logbook_entries, canUpdate ( in the organisation )     AND     the the requesting account must be the creator   )   A notification email will be sent when:   the stoppage and damage conditions are met   AND (     no mail has been send for that entry     OR     send_optional_notification is set to true   )
     * @summary updateLogbookEntry - Update a logbook entry
     * @param {string} organisationId The ID of the organisation
     * @param {string} logbookEntryId The ID of the logbook entry
     * @param {LogbookEntryUpdate} logbookEntryUpdate
     * @param {string} [sendOptionalNotification] When set to true notifications will be sent even if for that entry notifications were sent before. Notifications are only sent when the entry meets the basic conditions for sending notifications.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogbookEntriesApi
     */
    updateLogbookEntry(organisationId, logbookEntryId, logbookEntryUpdate, sendOptionalNotification, options) {
        return exports.LogbookEntriesApiFp(this.configuration).updateLogbookEntry(organisationId, logbookEntryId, logbookEntryUpdate, sendOptionalNotification, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.LogbookEntriesApi = LogbookEntriesApi;
/**
 * LogbookEntriesCommentsApi - axios parameter creator
 * @export
 */
const LogbookEntriesCommentsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Adds a entry to the comments history for the entry {logbookEntryId} within organisation {organisationId}. Required access rights (depend on comments entry type):   commented -> (     logbook_entries, canUpdate     OR     logbook_entries/all, canUpdate   )
         * @summary createLogbookEntryComment - Adds a comments entry ✅
         * @param {string} organisationId The ID of the organisation
         * @param {string} logbookEntryId The ID of the logbook entry
         * @param {CommentCreate} commentCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLogbookEntryComment: async (organisationId, logbookEntryId, commentCreate, options = {}) => {
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('createLogbookEntryComment', 'organisationId', organisationId);
            // verify required parameter 'logbookEntryId' is not null or undefined
            common_1.assertParamExists('createLogbookEntryComment', 'logbookEntryId', logbookEntryId);
            // verify required parameter 'commentCreate' is not null or undefined
            common_1.assertParamExists('createLogbookEntryComment', 'commentCreate', commentCreate);
            const localVarPath = `/organisations/{organisationId}/logbook-entries/{logbookEntryId}/comments`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)))
                .replace(`{${"logbookEntryId"}}`, encodeURIComponent(String(logbookEntryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(commentCreate, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the image of the comment entry of logbook entry {logbookEntryId} in organisation {organisationtId}. Requesting user must have sufficiant access rights. Required access rights:   logbook_entries/all, canRead   OR   logbook_entries, canRead
         * @summary getLogbookEntryCommentSignature - Return the image of the signature of the comment entry of a logbook entry  within a given organisation ✅
         * @param {string} organisationId The ID of the organisation
         * @param {string} logbookEntryId The ID of the logbook entry
         * @param {string} commentId The ID of the comment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogbookEntryCommentSignature: async (organisationId, logbookEntryId, commentId, options = {}) => {
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('getLogbookEntryCommentSignature', 'organisationId', organisationId);
            // verify required parameter 'logbookEntryId' is not null or undefined
            common_1.assertParamExists('getLogbookEntryCommentSignature', 'logbookEntryId', logbookEntryId);
            // verify required parameter 'commentId' is not null or undefined
            common_1.assertParamExists('getLogbookEntryCommentSignature', 'commentId', commentId);
            const localVarPath = `/organisations/{organisationId}/logbook-entries/{logbookEntryId}/comments/{commentId}/signature`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)))
                .replace(`{${"logbookEntryId"}}`, encodeURIComponent(String(logbookEntryId)))
                .replace(`{${"commentId"}}`, encodeURIComponent(String(commentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the list of comment entries for logbook entry {logbookEntryId} in organsation {organsationId} Requesting user must have sufficiant access rights. Required access rights:   logbook_entries/all, canRead   OR   logbook_entries, canRead
         * @summary getLogbookEntryComments - Return the list of comment entries for logbook entry {logbookEntryId} in organsation {organsationId}. ✅
         * @param {string} organisationId The ID of the organisation
         * @param {string} logbookEntryId The ID of the logbook entry
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {Set<'creatorAccountIdRef' | 'creatorAccountFirstName' | 'creatorAccountLastName' | 'creatorAccountEmailAddress' | 'createTimestamp' | 'newEntryState' | 'creatorAccountIdRef asc' | 'creatorAccountFirstName asc' | 'creatorAccountLastName asc' | 'creatorAccountEmailAddress asc' | 'createTimestamp asc' | 'newEntryState asc' | 'creatorAccountIdRef desc' | 'creatorAccountFirstName desc' | 'creatorAccountLastName desc' | 'creatorAccountEmailAddress desc' | 'createTimestamp desc' | 'newEntryState desc'>} [$orderby] An OData conformant $orderby string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogbookEntryComments: async (organisationId, logbookEntryId, $top, $skip, $count, $orderby, options = {}) => {
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('getLogbookEntryComments', 'organisationId', organisationId);
            // verify required parameter 'logbookEntryId' is not null or undefined
            common_1.assertParamExists('getLogbookEntryComments', 'logbookEntryId', logbookEntryId);
            const localVarPath = `/organisations/{organisationId}/logbook-entries/{logbookEntryId}/comments`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)))
                .replace(`{${"logbookEntryId"}}`, encodeURIComponent(String(logbookEntryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }
            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }
            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }
            if ($orderby) {
                localVarQueryParameter['$orderby'] = Array.from($orderby).join(base_1.COLLECTION_FORMATS.pipes);
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.LogbookEntriesCommentsApiAxiosParamCreator = LogbookEntriesCommentsApiAxiosParamCreator;
/**
 * LogbookEntriesCommentsApi - functional programming interface
 * @export
 */
const LogbookEntriesCommentsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.LogbookEntriesCommentsApiAxiosParamCreator(configuration);
    return {
        /**
         * Adds a entry to the comments history for the entry {logbookEntryId} within organisation {organisationId}. Required access rights (depend on comments entry type):   commented -> (     logbook_entries, canUpdate     OR     logbook_entries/all, canUpdate   )
         * @summary createLogbookEntryComment - Adds a comments entry ✅
         * @param {string} organisationId The ID of the organisation
         * @param {string} logbookEntryId The ID of the logbook entry
         * @param {CommentCreate} commentCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLogbookEntryComment(organisationId, logbookEntryId, commentCreate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLogbookEntryComment(organisationId, logbookEntryId, commentCreate, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Return the image of the comment entry of logbook entry {logbookEntryId} in organisation {organisationtId}. Requesting user must have sufficiant access rights. Required access rights:   logbook_entries/all, canRead   OR   logbook_entries, canRead
         * @summary getLogbookEntryCommentSignature - Return the image of the signature of the comment entry of a logbook entry  within a given organisation ✅
         * @param {string} organisationId The ID of the organisation
         * @param {string} logbookEntryId The ID of the logbook entry
         * @param {string} commentId The ID of the comment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLogbookEntryCommentSignature(organisationId, logbookEntryId, commentId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLogbookEntryCommentSignature(organisationId, logbookEntryId, commentId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Return the list of comment entries for logbook entry {logbookEntryId} in organsation {organsationId} Requesting user must have sufficiant access rights. Required access rights:   logbook_entries/all, canRead   OR   logbook_entries, canRead
         * @summary getLogbookEntryComments - Return the list of comment entries for logbook entry {logbookEntryId} in organsation {organsationId}. ✅
         * @param {string} organisationId The ID of the organisation
         * @param {string} logbookEntryId The ID of the logbook entry
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {Set<'creatorAccountIdRef' | 'creatorAccountFirstName' | 'creatorAccountLastName' | 'creatorAccountEmailAddress' | 'createTimestamp' | 'newEntryState' | 'creatorAccountIdRef asc' | 'creatorAccountFirstName asc' | 'creatorAccountLastName asc' | 'creatorAccountEmailAddress asc' | 'createTimestamp asc' | 'newEntryState asc' | 'creatorAccountIdRef desc' | 'creatorAccountFirstName desc' | 'creatorAccountLastName desc' | 'creatorAccountEmailAddress desc' | 'createTimestamp desc' | 'newEntryState desc'>} [$orderby] An OData conformant $orderby string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLogbookEntryComments(organisationId, logbookEntryId, $top, $skip, $count, $orderby, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLogbookEntryComments(organisationId, logbookEntryId, $top, $skip, $count, $orderby, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.LogbookEntriesCommentsApiFp = LogbookEntriesCommentsApiFp;
/**
 * LogbookEntriesCommentsApi - factory interface
 * @export
 */
const LogbookEntriesCommentsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.LogbookEntriesCommentsApiFp(configuration);
    return {
        /**
         * Adds a entry to the comments history for the entry {logbookEntryId} within organisation {organisationId}. Required access rights (depend on comments entry type):   commented -> (     logbook_entries, canUpdate     OR     logbook_entries/all, canUpdate   )
         * @summary createLogbookEntryComment - Adds a comments entry ✅
         * @param {string} organisationId The ID of the organisation
         * @param {string} logbookEntryId The ID of the logbook entry
         * @param {CommentCreate} commentCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLogbookEntryComment(organisationId, logbookEntryId, commentCreate, options) {
            return localVarFp.createLogbookEntryComment(organisationId, logbookEntryId, commentCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the image of the comment entry of logbook entry {logbookEntryId} in organisation {organisationtId}. Requesting user must have sufficiant access rights. Required access rights:   logbook_entries/all, canRead   OR   logbook_entries, canRead
         * @summary getLogbookEntryCommentSignature - Return the image of the signature of the comment entry of a logbook entry  within a given organisation ✅
         * @param {string} organisationId The ID of the organisation
         * @param {string} logbookEntryId The ID of the logbook entry
         * @param {string} commentId The ID of the comment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogbookEntryCommentSignature(organisationId, logbookEntryId, commentId, options) {
            return localVarFp.getLogbookEntryCommentSignature(organisationId, logbookEntryId, commentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the list of comment entries for logbook entry {logbookEntryId} in organsation {organsationId} Requesting user must have sufficiant access rights. Required access rights:   logbook_entries/all, canRead   OR   logbook_entries, canRead
         * @summary getLogbookEntryComments - Return the list of comment entries for logbook entry {logbookEntryId} in organsation {organsationId}. ✅
         * @param {string} organisationId The ID of the organisation
         * @param {string} logbookEntryId The ID of the logbook entry
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {Set<'creatorAccountIdRef' | 'creatorAccountFirstName' | 'creatorAccountLastName' | 'creatorAccountEmailAddress' | 'createTimestamp' | 'newEntryState' | 'creatorAccountIdRef asc' | 'creatorAccountFirstName asc' | 'creatorAccountLastName asc' | 'creatorAccountEmailAddress asc' | 'createTimestamp asc' | 'newEntryState asc' | 'creatorAccountIdRef desc' | 'creatorAccountFirstName desc' | 'creatorAccountLastName desc' | 'creatorAccountEmailAddress desc' | 'createTimestamp desc' | 'newEntryState desc'>} [$orderby] An OData conformant $orderby string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogbookEntryComments(organisationId, logbookEntryId, $top, $skip, $count, $orderby, options) {
            return localVarFp.getLogbookEntryComments(organisationId, logbookEntryId, $top, $skip, $count, $orderby, options).then((request) => request(axios, basePath));
        },
    };
};
exports.LogbookEntriesCommentsApiFactory = LogbookEntriesCommentsApiFactory;
/**
 * LogbookEntriesCommentsApi - object-oriented interface
 * @export
 * @class LogbookEntriesCommentsApi
 * @extends {BaseAPI}
 */
class LogbookEntriesCommentsApi extends base_1.BaseAPI {
    /**
     * Adds a entry to the comments history for the entry {logbookEntryId} within organisation {organisationId}. Required access rights (depend on comments entry type):   commented -> (     logbook_entries, canUpdate     OR     logbook_entries/all, canUpdate   )
     * @summary createLogbookEntryComment - Adds a comments entry ✅
     * @param {string} organisationId The ID of the organisation
     * @param {string} logbookEntryId The ID of the logbook entry
     * @param {CommentCreate} commentCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogbookEntriesCommentsApi
     */
    createLogbookEntryComment(organisationId, logbookEntryId, commentCreate, options) {
        return exports.LogbookEntriesCommentsApiFp(this.configuration).createLogbookEntryComment(organisationId, logbookEntryId, commentCreate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Return the image of the comment entry of logbook entry {logbookEntryId} in organisation {organisationtId}. Requesting user must have sufficiant access rights. Required access rights:   logbook_entries/all, canRead   OR   logbook_entries, canRead
     * @summary getLogbookEntryCommentSignature - Return the image of the signature of the comment entry of a logbook entry  within a given organisation ✅
     * @param {string} organisationId The ID of the organisation
     * @param {string} logbookEntryId The ID of the logbook entry
     * @param {string} commentId The ID of the comment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogbookEntriesCommentsApi
     */
    getLogbookEntryCommentSignature(organisationId, logbookEntryId, commentId, options) {
        return exports.LogbookEntriesCommentsApiFp(this.configuration).getLogbookEntryCommentSignature(organisationId, logbookEntryId, commentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Return the list of comment entries for logbook entry {logbookEntryId} in organsation {organsationId} Requesting user must have sufficiant access rights. Required access rights:   logbook_entries/all, canRead   OR   logbook_entries, canRead
     * @summary getLogbookEntryComments - Return the list of comment entries for logbook entry {logbookEntryId} in organsation {organsationId}. ✅
     * @param {string} organisationId The ID of the organisation
     * @param {string} logbookEntryId The ID of the logbook entry
     * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {Set<'creatorAccountIdRef' | 'creatorAccountFirstName' | 'creatorAccountLastName' | 'creatorAccountEmailAddress' | 'createTimestamp' | 'newEntryState' | 'creatorAccountIdRef asc' | 'creatorAccountFirstName asc' | 'creatorAccountLastName asc' | 'creatorAccountEmailAddress asc' | 'createTimestamp asc' | 'newEntryState asc' | 'creatorAccountIdRef desc' | 'creatorAccountFirstName desc' | 'creatorAccountLastName desc' | 'creatorAccountEmailAddress desc' | 'createTimestamp desc' | 'newEntryState desc'>} [$orderby] An OData conformant $orderby string
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogbookEntriesCommentsApi
     */
    getLogbookEntryComments(organisationId, logbookEntryId, $top, $skip, $count, $orderby, options) {
        return exports.LogbookEntriesCommentsApiFp(this.configuration).getLogbookEntryComments(organisationId, logbookEntryId, $top, $skip, $count, $orderby, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.LogbookEntriesCommentsApi = LogbookEntriesCommentsApi;
/**
 * MailRecipientsApi - axios parameter creator
 * @export
 */
const MailRecipientsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Return the list of email recipients that will receive an email in case an entry with defect is created within organisation {organsationId}. Requesting user must have sufficiant access rights. Required access rights:   logbook_entries/all, canCreate   OR   logbook_entries, canCreate
         * @summary getLogbookMailRecipients - Return the list of email recipients that will receive an email in case a logbook entry with defect is created in organisation {organsationId}. ✅
         * @param {string} organisationId The ID of the organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogbookMailRecipients: async (organisationId, options = {}) => {
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('getLogbookMailRecipients', 'organisationId', organisationId);
            const localVarPath = `/organisations/{organisationId}/logbook-mail-recipients`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.MailRecipientsApiAxiosParamCreator = MailRecipientsApiAxiosParamCreator;
/**
 * MailRecipientsApi - functional programming interface
 * @export
 */
const MailRecipientsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.MailRecipientsApiAxiosParamCreator(configuration);
    return {
        /**
         * Return the list of email recipients that will receive an email in case an entry with defect is created within organisation {organsationId}. Requesting user must have sufficiant access rights. Required access rights:   logbook_entries/all, canCreate   OR   logbook_entries, canCreate
         * @summary getLogbookMailRecipients - Return the list of email recipients that will receive an email in case a logbook entry with defect is created in organisation {organsationId}. ✅
         * @param {string} organisationId The ID of the organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLogbookMailRecipients(organisationId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLogbookMailRecipients(organisationId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.MailRecipientsApiFp = MailRecipientsApiFp;
/**
 * MailRecipientsApi - factory interface
 * @export
 */
const MailRecipientsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.MailRecipientsApiFp(configuration);
    return {
        /**
         * Return the list of email recipients that will receive an email in case an entry with defect is created within organisation {organsationId}. Requesting user must have sufficiant access rights. Required access rights:   logbook_entries/all, canCreate   OR   logbook_entries, canCreate
         * @summary getLogbookMailRecipients - Return the list of email recipients that will receive an email in case a logbook entry with defect is created in organisation {organsationId}. ✅
         * @param {string} organisationId The ID of the organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogbookMailRecipients(organisationId, options) {
            return localVarFp.getLogbookMailRecipients(organisationId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.MailRecipientsApiFactory = MailRecipientsApiFactory;
/**
 * MailRecipientsApi - object-oriented interface
 * @export
 * @class MailRecipientsApi
 * @extends {BaseAPI}
 */
class MailRecipientsApi extends base_1.BaseAPI {
    /**
     * Return the list of email recipients that will receive an email in case an entry with defect is created within organisation {organsationId}. Requesting user must have sufficiant access rights. Required access rights:   logbook_entries/all, canCreate   OR   logbook_entries, canCreate
     * @summary getLogbookMailRecipients - Return the list of email recipients that will receive an email in case a logbook entry with defect is created in organisation {organsationId}. ✅
     * @param {string} organisationId The ID of the organisation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailRecipientsApi
     */
    getLogbookMailRecipients(organisationId, options) {
        return exports.MailRecipientsApiFp(this.configuration).getLogbookMailRecipients(organisationId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.MailRecipientsApi = MailRecipientsApi;
/**
 * MetaApi - axios parameter creator
 * @export
 */
const MetaApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get metadata vehicles that the requesting account sees in the logbook context  The requesting account must have sufficient rights to perform this operation.  Required access rights (one of):   logbook_entries/all, canCreate   OR   logbook_entries, canCreate  Allowed odata filter properties:   vehicleId
         * @summary Get metadata vehicles that the requesting account sees in the logbook context
         * @param {string} organisationId The ID of the organisation
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {Set<'vehicleId'>} [$orderby] An OData conformant $orderby string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleMetadataInOrganisation: async (organisationId, $top, $skip, $filter, $count, $orderby, options = {}) => {
            // verify required parameter 'organisationId' is not null or undefined
            common_1.assertParamExists('getVehicleMetadataInOrganisation', 'organisationId', organisationId);
            const localVarPath = `/organisations/{organisationId}/vehicles`
                .replace(`{${"organisationId"}}`, encodeURIComponent(String(organisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AccessTokenInHeaderSchema required
            // http bearer authentication required
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if ($top !== undefined) {
                localVarQueryParameter['$top'] = $top;
            }
            if ($skip !== undefined) {
                localVarQueryParameter['$skip'] = $skip;
            }
            if ($filter !== undefined) {
                localVarQueryParameter['$filter'] = $filter;
            }
            if ($count !== undefined) {
                localVarQueryParameter['$count'] = $count;
            }
            if ($orderby) {
                localVarQueryParameter['$orderby'] = Array.from($orderby).join(base_1.COLLECTION_FORMATS.pipes);
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.MetaApiAxiosParamCreator = MetaApiAxiosParamCreator;
/**
 * MetaApi - functional programming interface
 * @export
 */
const MetaApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.MetaApiAxiosParamCreator(configuration);
    return {
        /**
         * Get metadata vehicles that the requesting account sees in the logbook context  The requesting account must have sufficient rights to perform this operation.  Required access rights (one of):   logbook_entries/all, canCreate   OR   logbook_entries, canCreate  Allowed odata filter properties:   vehicleId
         * @summary Get metadata vehicles that the requesting account sees in the logbook context
         * @param {string} organisationId The ID of the organisation
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {Set<'vehicleId'>} [$orderby] An OData conformant $orderby string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVehicleMetadataInOrganisation(organisationId, $top, $skip, $filter, $count, $orderby, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVehicleMetadataInOrganisation(organisationId, $top, $skip, $filter, $count, $orderby, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.MetaApiFp = MetaApiFp;
/**
 * MetaApi - factory interface
 * @export
 */
const MetaApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.MetaApiFp(configuration);
    return {
        /**
         * Get metadata vehicles that the requesting account sees in the logbook context  The requesting account must have sufficient rights to perform this operation.  Required access rights (one of):   logbook_entries/all, canCreate   OR   logbook_entries, canCreate  Allowed odata filter properties:   vehicleId
         * @summary Get metadata vehicles that the requesting account sees in the logbook context
         * @param {string} organisationId The ID of the organisation
         * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
         * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
         * @param {Set<'vehicleId'>} [$orderby] An OData conformant $orderby string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleMetadataInOrganisation(organisationId, $top, $skip, $filter, $count, $orderby, options) {
            return localVarFp.getVehicleMetadataInOrganisation(organisationId, $top, $skip, $filter, $count, $orderby, options).then((request) => request(axios, basePath));
        },
    };
};
exports.MetaApiFactory = MetaApiFactory;
/**
 * MetaApi - object-oriented interface
 * @export
 * @class MetaApi
 * @extends {BaseAPI}
 */
class MetaApi extends base_1.BaseAPI {
    /**
     * Get metadata vehicles that the requesting account sees in the logbook context  The requesting account must have sufficient rights to perform this operation.  Required access rights (one of):   logbook_entries/all, canCreate   OR   logbook_entries, canCreate  Allowed odata filter properties:   vehicleId
     * @summary Get metadata vehicles that the requesting account sees in the logbook context
     * @param {string} organisationId The ID of the organisation
     * @param {number} [$top] A OData conformant $top parameter. The (maximum) number of items in the reponse. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {number} [$skip] A OData conformant $skip parameter. The number of items skipped in the response. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {string} [$filter] An OData conformant $filter string. See: - http://docs.oasis-open.org/odata/odata/v4.01/odata-v4.01-part1-protocol.html#_Toc31358948 - https://www.odata.org/documentation/odata-version-2-0/uri-conventions
     * @param {boolean} [$count] A OData conformant $count parameter. When true, the total number of items in the collection (totalCount) and the total number of found items (foundCount) is returned. See: https://www.odata.org/documentation/odata-version-2-0/uri-conventions/
     * @param {Set<'vehicleId'>} [$orderby] An OData conformant $orderby string
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaApi
     */
    getVehicleMetadataInOrganisation(organisationId, $top, $skip, $filter, $count, $orderby, options) {
        return exports.MetaApiFp(this.configuration).getVehicleMetadataInOrganisation(organisationId, $top, $skip, $filter, $count, $orderby, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.MetaApi = MetaApi;
//# sourceMappingURL=api.js.map